import { accessibleBranchesQueryKey, useAccessibleBranches } from '../../../hooks/useAccessibleBranches'

export const purchaseBranchesQueryKey = accessibleBranchesQueryKey

export function usePurchaseBranches(enabled: boolean) {
  return useAccessibleBranches(enabled)
}
